import React from 'react';
import { ThemeProvider, useTheme } from '../ThemeContext';
import MoveHome from './MoveHome';
import HomeMoveNotices from './HomeMoveNotices';

function Screens() {
  const { colors } = useTheme();
  const brandColor = '#59c4c4';
  const screen = new URLSearchParams(window.location.search).get('screen') || 'both';
  const showMove = screen === 'both' || screen === 'move';
  const showNotice = screen === 'both' || screen === 'notice';
  return (
    <div style={{ background: colors.background, minHeight: '100vh', padding: '1rem', boxSizing: 'border-box' }}>
      {showMove ? (
        <div data-preview="move" style={{ marginBottom: '2rem' }}>
          <MoveHome
            colors={colors}
            brandColor={brandColor}
            sponsored
            onCancel={() => {}}
            submitMove={async () => ({})}
          />
        </div>
      ) : null}
      {showNotice ? (
        <div data-preview="notice">
          <HomeMoveNotices
            colors={colors}
            notices={[{
              id: 'preview-notice',
              homeowner_name: 'Alex Rivera',
              city: 'Tampa',
              state: 'FL',
              decision: 'keep',
              decided_at: null,
            }]}
            onDecide={async () => {}}
          />
        </div>
      ) : null}
    </div>
  );
}

export default function MovePreview() {
  const params = new URLSearchParams(window.location.search);
  const theme = params.get('theme') === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem('pacarion_theme', theme);
  } catch (error) {
    // Preview still renders with the stored theme.
  }
  return (
    <ThemeProvider>
      <Screens />
    </ThemeProvider>
  );
}
